import { isValidEmail as alfaIsValidEmail } from '@alfalab/utils';

import type { TValidatorValue } from './models';
import { composeValidators, validate } from './utils';
import { validateNotEmpty } from './not-empty';

const DEFAULT_EMAIL_MESSAGE = 'Email введен некорректно. Пример: example@domain.ru';

/**
 * Валидирует строку с Email используя общебанковскую регулярку
 */
export const isValidEmail = (value?: string): boolean => {
    // http://git.moscow.alfaintra.net/projects/EF/repos/utils/browse/packages/utils/src/is-valid-email
    return value ? alfaIsValidEmail(value) : false;
};

const validateEmailValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidEmail(value), DEFAULT_EMAIL_MESSAGE, customMessage);

export const validateEmail = (message?: string) =>
    composeValidators(validateNotEmpty(), validateEmailValue(message));
